<template>
    <v-timeline class="pt-0" dense align-top>

<!-- Solicitado -->
        <v-timeline-item fill-dot color="#0CA5A2" small>
            <v-icon slot="icon" center size="12" color="white">fas fa-check</v-icon>
            <div class="descricao-evento d-flex flex-column">
                <span class="descricao-evento-dt-registro">
                    {{ pedido.historico.dhStatusSolicitado | formataData(true, "ddd - DD/MM - HH:mm") }}
                </span>
                <span class="descricao-evento-status">Solicitado</span>
                <span class="descricao-evento-dt-prevista">
                    Para o dia
                    {{ pedido.dtEntregaDesejada | formataData(true, "DD/MM") }}
                </span>
            </div>
        </v-timeline-item>

<!-- Solicitado e Cancelado -->
        <v-timeline-item v-if="!pedido.historico.dhStatusConfirmado && pedido.historico.dhStatusCancelado"
                         class="mb-0 pb-5" small color="#FF5252" fill-dot>
            <v-icon slot="icon" center size="12px" color="white">fas fa-times</v-icon>
            <div class="descricao-evento d-flex flex-column">
                <span class="descricao-evento-dt-registro">
                    {{ pedido.historico.dhStatusCancelado | formataData(true, "ddd - DD/MM - HH:mm") }}
                </span>
                <span class="descricao-evento-status">Cancelado</span>
                <span class="descricao-evento-dt-prevista">
                    Pedido cancelado.
                </span>
                <span class="descricao-evento-dt-prevista text-capitalize">
                    {{ pedido.dsObservacao }}
                </span>
                <span v-if="pedido.dsObservacaoCancelado && pedido.dsObservacao !== pedido.dsObservacaoCancelado"
                      class="descricao-evento-dt-prevista text-capitalize">
                    {{ pedido.dsObservacaoCancelado }}
                </span>
            </div>
        </v-timeline-item>

<!-- Confirmado -->
        <v-timeline-item v-if="pedido.historico.dhStatusConfirmado" class="mb-0 pb-0" small color="#0CA5A2" fill-dot>
            <v-icon slot="icon" center size="12px" color="white">fas fa-check</v-icon>
            <div class="descricao-evento d-flex flex-column">
                <span class="descricao-evento-dt-registro">
                    {{ pedido.historico.dhStatusConfirmado | formataData(true, "ddd - DD/MM - HH:mm") }}
                </span>
                <span class="descricao-evento-status">Confirmado</span>
                <span class="descricao-evento-dt-prevista">
                    Para o dia
                    {{ pedido.historico.dtPrevista | formataData(false, "DD/MM") }}
                </span>
            </div>
        </v-timeline-item>
        <v-timeline-item v-else class="mb-0 pb-5" small color="white">
            <v-icon slot="icon" center size="25px" color="#7B9596">far fa-circle</v-icon>
            <div class="descricao-evento d-flex flex-column">
                <span class="descricao-evento-status">
                    Confirmado
                </span>
            </div>
        </v-timeline-item>
        <v-slide-y-transition group hide-on-leave>
            <v-timeline-item v-if="exibeHistorico" :key="i" class="mb-0 pb-0" small color="#7B9596"
                             v-for="(event, i) in pedido.historico.listaConfirmado.filter(evento => evento.dsStatusObservacao)">
                <v-card class="pa-0" color="#F2F5F3">
                    <v-card-title class="pa-2 d-flex">
                        <v-row>
                            <v-col class="descricao-evento-confirmado-status pa-1 pt-2 px-3">
                            <span class="descricao-evento-dt-registro descricao-evento-dt-registro-confirmado">
                                {{ event.dhStatusConfirmado | formataData(true, "DD/MM - HH:mm") }}
                            </span>
                            <span class="pt-3">
                                {{ event.dsStatusObservacao }}
                            </span>
                            </v-col>
                        </v-row>
                    </v-card-title>
                </v-card>
            </v-timeline-item>
        </v-slide-y-transition>

<!-- Exibe histórico -->
        <v-timeline-item v-if="pedido.historico.dhStatusConfirmado" hide-dot class="ma-0 pa-0" style="user-select: none;">
            <span @click="exibeHistorico = !exibeHistorico" v-if="exibeHistorico"
                  class="descricao-evento-historico clickable">
                Esconder histórico
                <v-icon x-small>fas fa-caret-up</v-icon>
            </span>
            <span @click="exibeHistorico = !exibeHistorico" v-else class="descricao-evento-historico clickable">Ver histórico
                    <v-icon x-small>fas fa-caret-down</v-icon>
            </span>
        </v-timeline-item>

<!-- Confirmado e Cancelado -->
        <v-timeline-item v-if="pedido.historico.dhStatusConfirmado && pedido.historico.dhStatusCancelado"
                         class="mb-0 py-5" small color="#FF5252" fill-dot>
            <v-icon slot="icon" center size="12px" color="white">fas fa-times</v-icon>
            <div class="descricao-evento d-flex flex-column">
                <span class="descricao-evento-dt-registro">
                    {{ pedido.historico.dhStatusCancelado | formataData(true, "ddd - DD/MM - HH:mm") }}
                </span>
                <span class="descricao-evento-status">Cancelado</span>
                <span class="descricao-evento-dt-prevista">
                    Pedido cancelado.
                </span>
                <span class="descricao-evento-dt-prevista text-capitalize">
                    {{ pedido.dsObservacao }}
                </span>
                <span v-if="pedido.dsObservacaoCancelado && pedido.dsObservacao !== pedido.dsObservacaoCancelado"
                      class="descricao-evento-dt-prevista text-capitalize">
                    {{ pedido.dsObservacaoCancelado }}
                </span>
            </div>
        </v-timeline-item>

<!-- Saiu para entrega -->
        <span v-if="!pedido.historico.dhStatusConfirmado">
            <v-timeline-item  fill-dot color="#BDCCCA" class="py-5" small>
                <div class="descricao-evento d-flex flex-column">
                    <span class="descricao-evento-status">
                        Saiu para entrega
                    </span>
                </div>
            </v-timeline-item>
        </span>

        <v-timeline-item v-else-if="!pedido.historico.dhStatusSaiuEntrega" class="mb-0 pb-5" small color="white">
            <v-icon slot="icon" center size="25px" color="#7B9596">far fa-circle</v-icon>
            <div class="descricao-evento d-flex flex-column">
                <span class="descricao-evento-status">
                    Saiu para entrega
                </span>
            </div>
        </v-timeline-item>

<!-- Dialog Saiu para Entrega -->
        <nota-fiscal-dialog v-else :pedido="pedido" :listaRacao="listaRacao" read-only
                            :saiuEntregaDialog.sync="saiuEntregaDialog">
            <template v-slot:activator="{ on }">
                <v-timeline-item  class="mb-0 pb-0" small color="#0CA5A2" fill-dot>
                    <v-icon slot="icon" center size="12px" color="white">fas fa-check</v-icon>
                    <div class="descricao-evento d-flex flex-column clickable"
                         v-on="on">
                        <span class="descricao-evento-dt-registro">
                            {{ pedido.historico.dhStatusSaiuEntrega | formataData(true, "ddd - DD/MM - HH:mm") }}
                        </span>
                        <span class="descricao-evento-status">Saiu para entrega</span>
                    </div>
                </v-timeline-item>
            </template>
        </nota-fiscal-dialog>

<!-- Entregue -->
        <span v-if="!pedido.historico.dhStatusSaiuEntrega">
        <v-timeline-item class="ultimo-timeline-item" fill-dot color="#BDCCCA" small>
            <div class="descricao-evento d-flex flex-column">
                <span class="descricao-evento-status">
                    Entregue
                </span>
            </div>
        </v-timeline-item>
        </span>
        <v-timeline-item class="mb-0 pb-0 ultimo-timeline-item" small color="white"
                         v-else-if="pedido.historico.dhStatusSaiuEntrega && !pedido.historico.dhStatusEntrega">
            <v-icon slot="icon" center size="25px" color="#7B9596">far fa-circle</v-icon>
            <div class="descricao-evento d-flex flex-column">
                <span class="descricao-evento-status">
                    Entregue
                </span>
            </div>
        </v-timeline-item>
        <v-timeline-item v-else class="mb-0 pb-0 ultimo-timeline-item" small
                         color="#0CA5A2" fill-dot>
            <v-icon slot="icon" center size="12px" color="white">fas fa-check</v-icon>
            <div class="descricao-evento d-flex flex-column">
                <span class="descricao-evento-dt-registro">
                    {{ pedido.historico.dhStatusEntrega | formataData(true, "ddd - DD/MM - HH:mm") }}
                </span>
                <span class="descricao-evento-status">Entregue</span>
                <span class="descricao-evento-dt-prevista">
                    Pedido entregue ao produtor.
                </span>
                <span class="descricao-evento-dt-prevista text-uppercase">
                    {{ pedido.historico.dtEntrega | formataData(false, "DD/MM") }} -
                    {{ pedido.historico.hrEntrega | formataHora('hh:mm') }}
                </span>
            </div>
        </v-timeline-item>
    </v-timeline>
</template>
<script>
import * as moment from 'moment';
import NotaFiscalDialog from "@/modules/pedidosRacao/components/detalhePedido/NotaFiscalDialog";
import {URLS} from "@/modules/pedidosRacao/resources";

export default {
    name: 'timeline-pedido',
    components: { NotaFiscalDialog },
    data() {
        return {
            saiuEntregaDialog: false,
            exibeHistorico: false,
            listaRacoesPedido: []
        }
    },
    props: {
        pedido: {},
        listaRacao: {
            type: Array,
            require: true
        }
    },
    filters: {
        formataData(date, ISO, formatoSaida) {
            let tipoData = ISO ? moment.ISO_8601 : 'YYYY-MM-DD';
            const parsedDate = moment(date, tipoData);
            if (!parsedDate.isValid()) return "";
            return parsedDate.format(formatoSaida);
        },
        formataHora(hora) {
            return hora.substr(0,5);
        },
    },
}
</script>
<style scoped lang="scss">
@import "../../sass/variables.scss";

.descricao-evento {
  width: 100%;
}

.descricao-evento-dt-registro {
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0.4px;
  color: $gray-100;
  text-transform: uppercase;
  opacity: 0.7;
}

.descricao-evento-dt-registro-confirmado {
  width: 72px;
  position: absolute;
  top: 4px;
  right: 0;
  z-index: 2;
}

.descricao-evento-dt-prevista {
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0;
  color: $gray-100;
  opacity: 0.7;
}

.descricao-evento-confirmado-status {
  font: normal normal bold 12px/16px Roboto;
  letter-spacing: 0;
  color: $gray-100;
  opacity: 0.7;
  word-break: break-word;
}

.descricao-evento-historico {
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0;
  color: $blue-200;
  opacity: 0.7;
}

.descricao-evento-status {
  font: normal normal bold 16px/21px Roboto;
  letter-spacing: 0;
  color: $gray-100;
  opacity: 0.7;
}

.v-timeline-item {
  margin: 24px 0;
}

.v-timeline:before {
  background: $gray-500 0 0 no-repeat padding-box !important;
  margin-left: -1px;
  width: 4px;
}

.clickable:hover {
  cursor: pointer;
  user-select: none;
}

.ultimo-timeline-item {
  height: 15px;
  margin-top: 48px;
}

.dialog-label {
  font: normal normal medium 16px/21px Roboto;
  letter-spacing: 0;
  color: $gray-100;
  opacity: 0.7;
}

.dialog-titulo {
  font: normal 300 normal 16px/21px Roboto !important;
  letter-spacing: 0;
  color: $gray-500;
}
</style>